import { render, staticRenderFns } from "./vpd-notification-panel.vue?vue&type=template&id=1b721fb9"
import script from "./vpd-notification-panel.vue?vue&type=script&lang=js"
export * from "./vpd-notification-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports